import { useState } from "react";
import { Button, DatePicker, Form, Input, Modal, Tag } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ListPage } from "../../components/ListPage";
import { useApi } from "../../helpers/useApi";
import { hasPermission } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import type { Project } from "../../api-models";
import { STATUS_COLORS } from "../../helpers/constants";

export default function ProjectsListPage() {
  const { user } = useUser();
  const canWrite = hasPermission(user, "Projects.Write");
  const { request } = useApi();
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const [reloadKey, setReloadKey] = useState(0);

  async function handleSubmit() {
    const values = await form.validateFields();
    await request({
      method: "POST",
      url: "/projects",
      data: { ...values, startDate: values.startDate?.toISOString() },
    });
    setOpen(false);
    setReloadKey((k) => k + 1);
  }

  return (
    <>
      <ListPage<Project>
        key={reloadKey}
        title="Projects"
        endpoint="/projects"
        searchPlaceholder="Search projects..."
        linkTo={(p) => `/projects/${p.id}`}
        actions={
          canWrite && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                form.resetFields();
                setOpen(true);
              }}
            >
              New project
            </Button>
          )
        }
        columns={[
          { title: "Code", dataIndex: "code", sorter: true },
          { title: "Name", dataIndex: "name", sorter: true },
          { title: "Status", dataIndex: "status", sorter: true, render: (v) => <Tag color={STATUS_COLORS[v]}>{v}</Tag> },
        ]}
        renderCard={(p) => (
          <div>
            <strong>{p.code}</strong> — {p.name}
            <div>
              <Tag color={STATUS_COLORS[p.status]}>{p.status}</Tag>
            </div>
          </div>
        )}
      />
      <Modal title="New project" open={open} onCancel={() => setOpen(false)} onOk={handleSubmit} destroyOnHidden>
        <Form form={form} layout="vertical">
          <Form.Item name="code" label="Code" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="name" label="Name" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="startDate" label="Start date">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
